export const KEYS = {
  AUTH: "/auth",
  AUTH_NONCE: "/auth/nonce",
  AUTH_VERIFY: "/auth/verify",
};
